export type AppEnvKind = "prod" | "test" | "local";

export const getAppEnvKind = (): AppEnvKind => {
  const raw = String(process.env["NEXT_PUBLIC_APP_ENV"] || "")
    .trim()
    .toLowerCase();

  if (raw === "production" || raw === "prod") return "prod";
  if (raw === "home-staging" || raw === "test" || raw === "staging")
    return "test";

  if (typeof window !== "undefined") {
    const host = String(window.location.hostname || "").toLowerCase();
    if (isTestHost(host)) return "test";
    if (host === "gltournament.ru" || host.endsWith(".gltournament.ru"))
      return "prod";
    if (host === "localhost" || host === "127.0.0.1") return "local";
  }

  return "local";
};

export const isTestHost = (host: string): boolean => {
  const h = String(host || "").trim().toLowerCase();
  if (!h) return false;
  if (h === "test.gltournament.ru") return true;
  if (h.endsWith(".test.gltournament.ru")) return true;
  return false;
};

export const isTestEnvClient = (): boolean => {
  if (typeof window === "undefined") return getAppEnvKind() === "test";
  return getAppEnvKind() === "test" || isTestHost(window.location.hostname);
};

export const isProdEnv = (): boolean => getAppEnvKind() === "prod";
export const isLocalEnv = (): boolean => getAppEnvKind() === "local";

